var exports = {
  "k": "container__alfVI-",
};

module.exports = exports;
